module.exports = "/assets/kinley-page/beverage_4@2x.png?A9QjyM6";